import { buildRunIdParam } from 'src/common/helpers/GQLRequestsHelper/buildRunIdParam';

import { MfaSessionDetailsQueryVariables } from '../MfaSessionDetails.generated';

export const buildMfaSessionDetailsQueryVariables = (
	sessionId: string
): MfaSessionDetailsQueryVariables => ({
	runId: buildRunIdParam(sessionId).runId
});
